var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M28 16a1 1 0 01-1 1H17v10a1 1 0 01-2 0V17H5a1 1 0 010-2h10V5a1 1 0 012 0v10h10a1 1 0 011 1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }